module.exports = __webpack_public_path__ + "fonts/6d51ac7.eot";